<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/K8pL6R/tc-custom/9781446379905.jpg?1709154777750" alt="This image is the cover for the book Alterknit Rebellion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Alterknit Rebellion
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A collection of bright, bold and beautiful knitting patterns based on Hönsestrikk, a Danish knitting movement that broke away from traditional rules.</b></p><p> Hönsestrikk, which loosely translates as “chicken stitch” was influenced by the radical social and political movements of the 1970s, including the women’s rights movement, and this can be seen in the personal and political messages of the some of the pattern designs. Instead of the more traditional fair isle colorwork techniques, Hönsestrikk knitting featured political messages and motifs, colors clashed and borders butted up against each other in a riot of color and pattern. </p><p> Hönsestrikk is about knitting in a freer style so you have the freedom to express yourself and create truly unique, personalized garments and accessories. </p><p> Designer Anna Bauer has been inspired by the Hönsestrikk movement to create this collection of basic designs and patterns so you can choose your own combinations and create and knit your own free, radical knits. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anna Bauer
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A David and Charles Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ab60d34